<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <div class="action-card">
          <el-button type="primary" size="medium" @click="openCreate">
            <i class="el-icon-plus"></i>
            开通访问令牌
          </el-button>
        </div>

        <div class="search-card">
          <el-form :inline="true" :model="searchForm" size="medium">
            <el-form-item label="名称">
              <el-input v-model="searchForm.name" placeholder="令牌名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.status" placeholder="全部" clearable>
                <el-option label="启用" value="1"></el-option>
                <el-option label="停用" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadList">查询</el-button>
              <el-button @click="resetSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">访问令牌</h3>
            <span class="data-count">共 {{total}} 条</span>
          </div>
          <el-table :data="list" v-loading="loading" border>
            <el-table-column type="index" label="#" width="55" align="center"></el-table-column>
            <el-table-column prop="name" label="名称" min-width="140"></el-table-column>
            <el-table-column label="令牌前缀" width="140">
              <template slot-scope="scope">
                <code>{{scope.row.token_prefix}}</code>
              </template>
            </el-table-column>
            <el-table-column label="资源范围" min-width="220">
              <template slot-scope="scope">
                <el-tag
                  v-for="s in (scope.row.scopes || [])"
                  :key="s"
                  size="mini"
                  :type="piiScope(s) ? 'warning' : 'success'"
                  style="margin:0 4px 4px 0">
                  {{scopeLabel(s)}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  active-value="1"
                  inactive-value="0"
                  @change="toggleStatus(scope.row)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="expire_at" label="过期时间" width="170"></el-table-column>
            <el-table-column prop="last_used_at" label="最近使用" width="170"></el-table-column>
            <el-table-column prop="last_used_ip" label="最近IP" width="140"></el-table-column>
            <el-table-column label="操作" width="160" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
                <el-popconfirm title="确定删除该令牌？删除后客服系统将立即失效。" @confirm="remove(scope.row.id)">
                  <el-button slot="reference" type="text" size="mini" style="color:#F56C6C">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div class="pager">
            <el-pagination
              background
              layout="total, prev, pager, next"
              :page-size="pageSize"
              :current-page.sync="currentPage"
              :total="total"
              @current-change="loadList">
            </el-pagination>
          </div>
        </div>
      </div>
    </PageHeaderLayout>

    <el-dialog :title="form.id ? '编辑访问令牌' : '开通访问令牌'" :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="例如：官网客服 / Zendesk"></el-input>
        </el-form-item>
        <el-form-item label="开放资源" prop="scopes">
          <el-checkbox-group v-model="form.scopes">
            <div v-for="item in catalog" :key="item.key" class="scope-item">
              <el-checkbox :label="item.key">
                {{item.label}}
                <el-tag size="mini" :type="item.need_identity ? 'warning' : 'info'">
                  {{item.need_identity ? '需对人/对单' : '目录资料'}}
                </el-tag>
              </el-checkbox>
              <p class="scope-desc">{{item.desc}}</p>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-date-picker v-model="form.expire_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="不填则长期有效"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="请立即复制令牌" :visible.sync="tokenVisible" width="560px" :close-on-click-modal="false">
      <el-alert type="warning" :closable="false" show-icon title="明文令牌只显示一次，关闭后无法再次查看。"></el-alert>
      <p style="margin:16px 0 8px">{{issued.name}}</p>
      <el-input v-model="issued.token" readonly>
        <el-button slot="append" @click="copyToken">复制</el-button>
      </el-input>
      <p class="hint">客服系统请求头：<code>X-Open-Token</code> 或 <code>Authorization: Bearer</code></p>
      <p class="hint">查询订单必须同时提供订单号 + 下单邮箱或手机，且必须与客户资料对得上。</p>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  components: { PageHeaderLayout },
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      searchForm: { name: '', status: '' },
      catalog: [],
      dialogVisible: false,
      tokenVisible: false,
      issued: { name: '', token: '' },
      form: { id: '', name: '', scopes: [], expire_at: '', remark: '' },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        scopes: [{ type: 'array', required: true, min: 1, message: '请至少选择一项资源', trigger: 'change' }]
      }
    }
  },
  methods: {
    scopeLabel(key) {
      const hit = (this.catalog || []).find(i => i.key === key)
      return hit ? hit.label : key
    },
    piiScope(key) {
      const hit = (this.catalog || []).find(i => i.key === key)
      return !!(hit && hit.need_identity)
    },
    resetSearch() {
      this.searchForm = { name: '', status: '' }
      this.currentPage = 1
      this.loadList()
    },
    async loadScopes() {
      const res = await this.$api.post('/service/open_token/scopes', {})
      if (this.$apiSuccess(res)) {
        this.catalog = (res.data && res.data.scopes) || []
      }
    },
    async loadList() {
      this.loading = true
      const res = await this.$api.post('/service/open_token/list', {
        name: this.searchForm.name,
        status: this.searchForm.status,
        current_page: this.currentPage,
        page_size: this.pageSize
      })
      this.loading = false
      if (this.$apiSuccess(res)) {
        this.list = res.data.list || []
        this.total = res.data.total || 0
      } else {
        this.$message.error(res.message || '加载失败')
      }
    },
    openCreate() {
      this.form = { id: '', name: '', scopes: ['faq'], expire_at: '', remark: '' }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        scopes: [...(row.scopes || [])],
        expire_at: row.expire_at || '',
        remark: row.remark || ''
      }
      this.dialogVisible = true
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.saving = true
        const url = this.form.id ? '/service/open_token/update' : '/service/open_token/create'
        const res = await this.$api.post(url, this.form)
        this.saving = false
        if (!this.$apiSuccess(res)) {
          this.$message.error(res.message || '保存失败')
          return
        }
        this.dialogVisible = false
        if (!this.form.id && res.data && res.data.token) {
          this.issued = { name: res.data.name, token: res.data.token }
          this.tokenVisible = true
        } else {
          this.$message.success('保存成功')
        }
        this.loadList()
      })
    },
    async toggleStatus(row) {
      const res = await this.$api.post('/service/open_token/update', { id: row.id, status: row.status })
      if (this.$apiSuccess(res)) {
        this.$message.success('状态已更新')
      } else {
        this.$message.error(res.message || '更新失败')
        this.loadList()
      }
    },
    async remove(id) {
      const res = await this.$api.post('/service/open_token/delete', { id })
      if (this.$apiSuccess(res)) {
        this.$message.success('已删除')
        this.loadList()
      } else {
        this.$message.error(res.message || '删除失败')
      }
    },
    copyToken() {
      const t = this.issued.token
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t).then(() => this.$message.success('已复制'))
        return
      }
      const input = document.createElement('input')
      input.value = t
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('已复制')
    }
  },
  mounted() {
    this.loadScopes()
    this.loadList()
  }
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
.action-card, .search-card, .table-card
  background #fff
  border-radius 12px
  padding 20px 24px
  margin-bottom 16px
  box-shadow 0 2px 12px rgba(0,0,0,.06)
.table-header
  display flex
  justify-content space-between
  align-items center
  margin-bottom 12px
.table-title
  margin 0
  font-size 16px
.data-count
  color #909399
  font-size 13px
.pager
  margin-top 16px
  text-align right
.scope-item
  margin-bottom 8px
.scope-desc
  margin 0 0 8px 24px
  color #909399
  font-size 12px
  line-height 1.4
.hint
  margin-top 12px
  color #909399
  font-size 12px
code
  font-size 12px
</style>
